var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBucketPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99964 2.75338C10.3448 2.75338 10.6246 3.0332 10.6246 3.37838V17.6216C10.6246 17.9668 10.3448 18.2466 9.99964 18.2466C9.65446 18.2466 9.37464 17.9668 9.37464 17.6216V3.37838C9.37464 3.0332 9.65446 2.75338 9.99964 2.75338Z",
    fill: "#0B0C0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25302 10.5C2.25302 10.1548 2.53285 9.875 2.87802 9.875L17.1213 9.875C17.4664 9.875 17.7463 10.1548 17.7463 10.5C17.7463 10.8452 17.4664 11.125 17.1213 11.125L2.87802 11.125C2.53285 11.125 2.25302 10.8452 2.25302 10.5Z",
    fill: "#0B0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucketPlus);
export default __webpack_public_path__ + "static/media/bucket_plus.5c63834c2c71a131b3e4dd367895b3d8.svg";
export { ForwardRef as ReactComponent };